
const ReportsAccordion = ({ reports, expandedSections, toggleSection }) => {
  if (!reports || !Array.isArray(reports) || reports.length === 0) {
    return (
      <div className="text-center text-gray-500 dark:text-gray-400 py-8">
        No reports available
      </div>
    );
  }

  const formatDate = (timestamp) => {
    if (!timestamp) return '-';
    try {
      return new Date(timestamp).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return '-';
    }
  };

  const formatName = (report) => {
    const firstName = report?.firstName?.trim() || '';
    const lastName = report?.lastName?.trim() || '';
    if (firstName || lastName) {
      return `${firstName} ${lastName}`.trim();
    }
    return '-';
  };

  const formatTitle = (report, index) => {
    const name = formatName(report);
    const email = report?.email?.trim();
    
    if (name !== '-' && email) {
      return `Report ${index + 1} (${name} <${email}>)`;
    } else if (name !== '-') {
      return `Report ${index + 1} (${name})`;
    } else if (email) {
      return `Report ${index + 1} (<${email}>)`;
    } else {
      return `Report ${index + 1}`;
    }
  };

  return (
    <div className="space-y-2">
      {reports.map((report, index) => (
        <div key={index} className="border border-gray-200 dark:border-gray-600 rounded-lg overflow-hidden">
          <button
            className="w-full flex items-center justify-between p-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors text-left"
            onClick={() => toggleSection(`report-${index}`)}
          >
            <span className="font-medium text-gray-900 dark:text-white">
              {formatTitle(report, index)}
            </span>
            <svg
              className={`w-4 h-4 transition-transform text-gray-600 dark:text-gray-300 ${
                expandedSections.has(`report-${index}`) ? 'rotate-180' : ''
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          {expandedSections.has(`report-${index}`) && (
            <div className="p-4 bg-white dark:bg-gray-800 space-y-2 text-sm text-gray-800 dark:text-gray-200">
              <div className="flex justify-between">
                <span className="text-gray-600 dark:text-gray-400">Name</span>
                <span className="font-medium text-right break-words">{formatName(report)}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600 dark:text-gray-400">Email</span>
                <span className="font-medium text-right break-words">{report?.email || '-'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600 dark:text-gray-400">Postcode</span>
                <span className="font-medium text-right break-words">{report?.postcode || '-'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600 dark:text-gray-400">Contact</span>
                <span className="font-medium text-right break-words">
                  {report?.contact === true ? 'Yes' : report?.contact === false ? 'No' : '-'}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600 dark:text-gray-400">Phone</span>
                <span className="font-medium text-right break-words">{report?.phone || '-'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600 dark:text-gray-400">Comments</span>
                <span className="font-medium text-right break-words">{report?.comments || '-'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600 dark:text-gray-400">List</span>
                <span className="font-medium text-right break-words">
                  {report?.list === true ? 'Yes' : report?.list === false ? 'No' : '-'}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600 dark:text-gray-400">Best Description</span>
                <span className="font-medium text-right break-words">{report?.bestDescription || '-'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600 dark:text-gray-400">Riding Discipline</span>
                <span className="font-medium text-right break-words">{report?.ridingDiscipline || '-'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600 dark:text-gray-400">Report Date</span>
                <span className="font-medium text-right break-words">{formatDate(report?.reportDate)}</span>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ReportsAccordion;